import { atom, useAtomValue, useSetAtom } from 'jotai';

type StoreNameMap = Record<string, string>;
/** 本地搜索需映射 shopId 到名字 */
export const searchMsgStoreName = atom<StoreNameMap>({});

export const useSearchMsgStoreName = () => {
  return useAtomValue(searchMsgStoreName);
};

export const useSetSearchMsgStoreName = () => {
  return useSetAtom(searchMsgStoreName);
};
